import { ChevronDown, ChevronRight } from 'lucide-react'
import { useState } from 'react'

import { Button } from '@/components/ui/button'

interface CollapsibleSectionProps {
  title: string
  icon: React.ReactNode
  children: React.ReactNode
  defaultOpen?: boolean
  className?: string
  hasErrors?: boolean
}

const CollapsibleSection = ({
  title,
  icon,
  children,
  defaultOpen = false,
  className = '',
  hasErrors = false,
}: CollapsibleSectionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen)

  const borderClass = hasErrors
    ? 'border-red-300 dark:border-red-700 bg-red-50 dark:bg-red-900/10'
    : 'border-gray-200 dark:border-gray-700'

  const buttonHoverClass = hasErrors
    ? 'hover:bg-red-100 dark:hover:bg-red-900/20'
    : 'hover:bg-gray-50 dark:hover:bg-gray-700/50'

  const titleClass = hasErrors
    ? 'text-red-900 dark:text-red-100'
    : 'text-gray-900 dark:text-white'

  return (
    <div className={`border rounded-lg ${borderClass} ${className}`}>
      <Button
        variant="ghost"
        onClick={() => setIsOpen(!isOpen)}
        className={`w-full p-4 flex items-center justify-between text-left ${buttonHoverClass} rounded-lg`}
      >
        <div className="flex items-center space-x-2">
          {icon}
          <h3 className={`font-medium ${titleClass}`}>{title}</h3>
        </div>
        {isOpen ? (
          <ChevronDown className="w-4 h-4 text-gray-500 dark:text-gray-400" />
        ) : (
          <ChevronRight className="w-4 h-4 text-gray-500 dark:text-gray-400" />
        )}
      </Button>

      {isOpen && <div className="px-4 pb-4">{children}</div>}
    </div>
  )
}

export default CollapsibleSection
